export default "__VITE_ASSET__BgNVth3U__"